import React from 'react';
import { Grid, Box, Pagination, AmountSelector, PageSelector, NextPreviousBtn } from '@blueprint/ui';
import { Table, TableBodyCell, TableHeadCell, TableBodyRow, TableHeadRow, TableHead, TableBody, TSortLabel } from '@blueprint/table';
import { useTable, usePagination, useSortBy } from 'react-table';

const AmountComponent = ({ children, count, prefixText: PrefixText, suffixText: SuffixText }) => (
    <>
        <PrefixText>Show</PrefixText>
        {children}
        <SuffixText>of {count} payments</SuffixText>
    </>
);

const amountOptions = [
    { label: '5', value: '5' },
    { label: '10', value: '10' },
    { label: '20', value: '20' },
    { label: '50', value: '50' },
];

const TableClientPagination = ({ data, columns, id }) => {
    const {
        previousPage,
        nextPage,
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setPageSize,
        gotoPage,
        state: { pageIndex, pageSize },
    } = useTable({ data, columns, ...{ disableSortRemove: true } }, useSortBy, usePagination);

    return (
        <>
            <Grid container style={{ overflowX: 'auto', msOverflowStyle: '-ms-autohiding-scrollbar' }}>
                <Table {...getTableProps()} tableHover width='100%' id={id}>
                    <TableHead>
                        {headerGroups.map((headerGroup) => (
                            <TableHeadRow {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => {
                                    return (
                                        <TableHeadCell
                                            cellType='sortable'
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            isSorted={column.isSorted}
                                            aria-sort={column.canSort ? (column.isSortedDesc ? 'descending' : 'ascending') : undefined}
                                            onKeyPress={(event) => {
                                                if (event.charCode === 13) {
                                                    column.toggleSortBy();
                                                }
                                            }}
                                        >
                                            {column.render('Header')}
                                            <TSortLabel
                                                aria-label={'Sort ' + `${column.Header}`}
                                                sortType={column.canSort ? (column.isSortedDesc ? 'descending' : 'ascending') : undefined}
                                            />
                                        </TableHeadCell>
                                    );
                                })}
                            </TableHeadRow>
                        ))}
                    </TableHead>
                    <TableBody {...getTableBodyProps()}>
                        {rows.map((row, i) => {
                            // Ignore this warning or just return something to suppress it
                            if (
                                // This "if" ensures that records are displayed according to 'Page Size' and 'Selected Page'
                                pageIndex * pageSize <= i &&
                                i < (pageIndex + 1) * pageSize
                            ) {
                                prepareRow(row);

                                return (
                                    <TableBodyRow {...row.getRowProps()}>
                                        {row.cells.map((cell, index) => {
                                            return (
                                                <TableBodyCell
                                                    onClick={() => {
                                                        console.log('Logging Cell', cell.row.original);
                                                    }}
                                                    {...cell.getCellProps()}
                                                    id={`row${row.id}col${index}`}
                                                    textAlign={typeof cell.value === 'number' ? 'right' : 'left'}
                                                    style={{ height: '-webkit-fill-available' }}
                                                >
                                                    {cell.render('Cell')}
                                                </TableBodyCell>
                                            );
                                        })}
                                    </TableBodyRow>
                                );
                            }
                        })}
                    </TableBody>
                </Table>
            </Grid>
            {data.length > 10 ? (
                <Grid container>
                    <Pagination
                        count={data.length}
                        defaultCountPerPage={10}
                        defaultCurrentPage={1}
                        mt='20px'
                        mb='15px'
                        width='100%'
                        display='flex'
                        flexWrap='wrap'
                    >
                        <AmountSelector
                            id='pl-dropdown-pageSize'
                            amountComponent={AmountComponent}
                            options={amountOptions}
                            onAmountChange={(countPerPage) => {
                                setPageSize(countPerPage);
                                gotoPage(0);
                            }}
                        />
                        <Box display='flex'>
                            <PageSelector
                                id='pl-dropdown-pageSelector'
                                isSearchable={true}
                                onPageChange={(currentPage, event, { countPerPage }) => {
                                    gotoPage(currentPage - 1);
                                }}
                            />
                            <NextPreviousBtn
                                id='pl-buttons-nextPrevious'
                                previousOnClick={(newCurrentPage, count, { countPerPage }) => {
                                    previousPage();
                                }}
                                nextOnClick={(newCurrentPage, count, { countPerPage }) => {
                                    nextPage();
                                }}
                            />
                        </Box>
                    </Pagination>
                </Grid>
            ) : null}
        </>
    );
};

export default TableClientPagination;
